import ILocalOrder from "shared/interfaces/LocalOrder.interface";
import IRestaurant from "shared/interfaces/Restaurant.interface";
import { getClosestOpeningDate } from "shared/utils/date";

export default (
  restaurant: IRestaurant,
  maxDays: number,
  localOrder: ILocalOrder
) => !!getClosestOpeningDate(restaurant, maxDays, localOrder);
